import React from "react";
import styles from "./LeftNavBar.module.scss";
import { formatNumberWithSpaces } from "../../utils/methods/numberFormatter";
import { ExitIcon } from "../../assets/icons/ExitIcon";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUser } from "../../store/slices/userSlice";

export const UserContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state?.user?.data);
  const billing = useSelector((state) => state?.billing?.data);
  const ballance = billing?.ballance || user?.billing?.ballance;

  const getInitials = (name, surname) => {
    const firstInitial = name?.charAt(0).toUpperCase() || "";
    const lastInitial = surname?.charAt(0).toUpperCase() || "";
    return `${firstInitial}${lastInitial}`;
  };

  const handlerExit = () => {
    dispatch(removeUser());
    dispatch({ type: "reset" });
    navigate("/");
  };

  const goToWallet = () => navigate("/wallet");
  const goToProfile = () => navigate("/profile");

  return (
    <div className={styles.userContainer}>
      <div className={`${styles.initials}`} onClick={goToProfile}>
        {getInitials(user?.firstName, user?.surname)}
      </div>
      <div className={styles.userInfo}>
        <div className={styles.itemUserName} onClick={goToProfile}>
          {user?.surname} {user?.firstName} {user?.patronymic}
        </div>
        <div className={styles.itemUserWallet}>
          <div
            onClick={goToWallet}
            className={`${styles.userBalance} ${
              ballance === 0 ? styles.pulsingRed : styles.color
            }`}
          >
            {formatNumberWithSpaces(ballance)} ₽
          </div>
          <div className={styles.exit} onClick={handlerExit}>
            <ExitIcon fill="#006AD7" />
          </div>
        </div>
      </div>
    </div>
  );
};
